import { flattenArray } from '@/helpers/array';

const ERROR_TEXT = 'Произошла непредвиденная ошибка, сообщите об ошибке администратору.';

export const RESPONSE_CODES = {
  FLSCS: 'Полный успех',
  RES01: 'Выполнено частично',
  RES02: 'Выполнено с ошибками',
  RES03: 'Изменения отсутствуют',
  RES04: 'Действие успешно, подозрение на ошибку пользователя',
  RES05: 'Не выполнено, действие невозможно совершить',
  EMP01: 'Запрос интерпретирован как пустой',
  LST01: 'Запись не найдена',
  ACC01: 'Нет прав на просмотр этой записи',
  ACC02: 'Нет прав на редактирование этой записи',
  ACC03: 'Нет прав на удаление этой записи',
  BLK01: 'Изменение записи заблокировано',
  BLK02: 'Удаление записи заблокировано',
  PRP01: 'Нельзя изменить определенные свойства записи',
  MST01: 'Отсутствуют обязательные параметры',
  VAL01: 'Не пройдена валидация',
  UNI01: 'Ограничение уникальности',
  UNTF: 'Пользователь системы не определен',
};

const getApiErrorMessage = (errorResponse) => {
  const error = errorResponse?.response?.data;

  if (!error) return ERROR_TEXT;

  const {
    result_code,
    result_message,
    data,
    validation,
    errors,
  } = error || {};

  const messages = validation || errors;

  if (messages) {
    if (Array.isArray(Object.values(messages))) {
      return flattenArray(Object.values(messages)).join(' \n');
    }
    return Object.values(messages).join(' \n');
  }

  return data?.message || result_message || RESPONSE_CODES[result_code] || ERROR_TEXT;
};

export default getApiErrorMessage;
